export const barOptions = {
    scales: {
        xAxes: [{
            stacked: true,
        }],
        yAxes: [{
            stacked: false,
            ticks: {
                beginAtZero: true
            },
        }]
    },
    tooltips: {
        mode: 'point'
    },
    onHover: function (event) {
        event.srcElement.style.cursor = 'default';
    },
    legend: {
        position: 'bottom',
        onHover: function (event, legendItem) {
            if (legendItem)
                event.srcElement.style.cursor = 'pointer';
        }
    },
    onResize: function() {
        $("#tiles").trigger("resize");
    }
}

export const pieOptions = {
    aspectRatio:  0,
    responsive: true,
    maintainAspectRatio: true,
    tooltips: {
        mode: 'point'
    },
    onHover: function (event) {
        event.srcElement.style.cursor = 'default';
    },
    legend: {
        display: true,
        position: 'top',
        onHover: function (event, legendItem) {
            if (legendItem)
                event.srcElement.style.cursor = 'pointer';
        },
    },
    onResize: function() {
        $("#tiles").trigger("resize");
    }
}

export const modalPieOptions =  {
    aspectRatio: 0,
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
        mode: 'point'
    },
    onHover: function (event) {
        event.srcElement.style.cursor = 'default';
    },
    legend: {
        display: false,
    },
    onResize: function() {
        $("#tiles").trigger("resize");
    }
}